export default function SubdomainRedirect() {
  // This component is no longer needed - SubdomainHandler handles subdomain routing
  return null;
}
